<template>
  <div>
    <van-sticky>
      <van-nav-bar title="退款/售后" left-arrow @click-left="onClickLeft" />
    </van-sticky>
    <div class="page">
      <div class="goods-list" style="margin: 10px">
        <div class="goods-item" v-for="(item, index) in list" :key="index">
          <div class="goods-item-tips">
            <div>
              <div class="rmb-icon">
                <!-- 仅退款 -->
                <img
                  src="http://img.zhujiaxian.com/2023/11/c4f5d6e7479044408a8f3190998e99f6.png"
                  v-if="item.applyType == 1"
                  alt=""
                />
                <!-- 退货退款 -->
                <img
                  src="http://img.zhujiaxian.com/2023/11/c4f5d6e7479044408a8f3190998e99f6.png"
                  v-if="item.applyType == 2"
                  alt=""
                />
              </div>
              <!-- applyType  申请类型:1,仅退款,2退款退货 -->
              <!-- 处理退款状态:(1.买家申请 2.卖家接受 3.买家发货 4.卖家收货 5.退款成功 6.买家撤回申请 7.商家拒绝 -1.退款关闭) -->
              <span class="refund-type" v-if="item.applyType == 1">仅退款</span>
              <span class="refund-type" v-if="item.applyType == 2"
                >退货退款</span
              >
            </div>
            <span class="refund-process" v-if="item.returnMoneySts == 1"
              >你已提交退款申请，等待商家处理</span
            >
            <span
              class="refund-process"
              v-if="item.returnMoneySts == 2 && item.applyType == 1"
              >商家已同意，等待退款</span
            >
            <span
              class="refund-process"
              v-if="item.returnMoneySts == 2 && item.applyType == 2"
              >商家已同意，请按照商家给出的地址寄回商品</span
            >
            <span
              class="refund-process"
              v-if="item.returnMoneySts == 3 && item.applyType == 2"
              >等待商家确认收货并退款</span
            >
            <span
              class="refund-process"
              v-if="item.returnMoneySts == 4 && item.applyType == 2"
              >商家已确认收货，等待退款到账</span
            >
            <span class="refund-process" v-if="item.returnMoneySts == 5"
              >退款完成</span
            >
            <span class="refund-process" v-if="item.returnMoneySts == 6"
              >退款申请已撤销</span
            >
            <span class="refund-process" v-if="item.returnMoneySts == 7"
              >商家拒绝，可修改退款申请或申请客服介入处理</span
            >
            <span class="refund-process" v-if="item.returnMoneySts == -1"
              >退款申请已关闭</span
            >
          </div>
          <div
            style="
              margin: 5px 10px;
              font-family: HarmonyOS-SC-Reg;
              color: #747876;
              font-size: 13px;
              font-weight: 400;
            "
          >
            <span>订单编号 {{ item.orderNumber }}</span>
          </div>
          <div v-if="item.orderItems.length == 1">
            <div
              class="item-cont"
              v-for="(prod, i) in item.orderItems"
              :key="i"
            >
              <div class="prod-pic">
                <img :src="prod.pic" alt="" style="width: 100%; height: 100%" />
              </div>
              <div class="prod-info">
                <div class="prodname">{{ prod.prodName }}</div>
                <div class="prod-info-cont">
                  <div class="prod-skuname">{{ prod.skuName }}</div>
                </div>
                <div class="price-nums">
                  <!-- <span class="prodprice">
                    <span class="symbol">￥</span>
                    <span class="big-num">{{ prod.price.toFixed(2) }}</span>
                  </span> -->
                  <span class="prodcount">数量 ：{{ prod.prodCount }}件</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="prod-item">
              <div class="item-cont">
                <div
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    width: 100%;
                    overflow-x: auto;
                  "
                >
                  <div
                    class="prod-pic"
                    v-for="(prod, i) in item.orderItems"
                    :key="i"
                  >
                    <img
                      :src="prod.pic"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item-bottom" @click="toRefund(item.refundSn)">
            <span  class="view-details">退货详情</span>
          </div>
        </div>
        <div class="empty" v-if="list.length==0">您还没有退款/售后订单哦~</div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetorderRefund } from "@/https/http";
export default {
  data() {
    return {
      list: [],
      current: 1,
      pages: 0,
      startTime: "", //开始时间
      endTime: "", //结束时间
    };
  },
  created() {
    this.orderRefund();
  },
  methods: {
    toRefund(o){
        this.$router.push({ path: "/DetailsOfRefund",query:{o} });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    orderRefund() {
      GetorderRefund(this.current).then((res) => {
        console.log(res.data);
        var list = [];
        if (res.data.current == 1) {
          list = res.data.records;
        } else {
          list = this.list;
          Array.prototype.push.apply(list, res.data.records);
        }
        this.list = list;
        this.pages = res.data.pages;
        this.current = res.data.current;
      });
    },
  },
};
</script>
<style scoped lang="less">
.page {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  overflow: auto;
}
.goods-item {
  background: #fff;
  margin-bottom: 10px;
  border-radius: 12px;
}
.goods-item-tips {
  padding: 10px;
  font-size: 13px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rmb-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 7px;
  img {
    width: 100%;
    height: 100%;
  }
}
.refund-type {
  vertical-align: middle;
  color: #0d1401;
  margin-right: 7px;
  font-size: 16px;
  font-weight: 500;
  font-family: sans-serif;
}
.refund-process {
  vertical-align: middle;
  color: #666;
}
.item-cont {
    position: relative;
    display: flex;
    background: #ffffff;
    align-items: center;
    padding: 10px 15px;
    border-radius: 5px;
    .prod-pic {
      position: relative;
      font-size: 0;
      display: inline-block;
      width: 80px;
      height: 80px;
      overflow: hidden;
      background: #fff;
      margin-right: 8px;
      border: 1px solid #eeeeee;
      border-radius: 12px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .prod-info {
      margin-left: 5px;
      font-size: 14px;
      width: 100%;
      position: relative;
      height: 85px;
      -ms-flex: 1;
      -webkit-box-flex: 1;
      -moz-box-flex: 1;
      flex: 1;
      .prodname {
        font-size: 14px;
        line-height: 18px;
        max-height: 43px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .prod-info-cont {
        display: inline-block;
        vertical-align: middle;
        padding-bottom: 5px;
        line-height: 1em;
        .prod-skuname {
          color: #999;
          line-height: 20px;
          margin-top: 5px;
          font-size: 12px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-all;
        }
      }
      .prodprice {
        color: #333;
        position: absolute;
        bottom: 0;
        .symbol {
          font-size: 12px;
        }
        .big-num {
          font-size: 16px;
        }
        .small-num {
          font-size: 12px;
        }
      }
      .prodcount {
        position: absolute;
        bottom: 2px;
        right: 0;
        color: #999;
        font-family: verdana;
      }
    }
  }
  .item-bottom {
    padding:7px 10px;
    text-align: right;
    line-height: 1em;
}
.view-details {
    display: inline-block;
    font-size: 13px;
    vertical-align: middle;
    border: 1px solid #747876;
    padding: 5px 13px;
    border-radius: 25px;
}

.empty{
  font-size: 15px;
  text-align: center;
  height:100px;
  line-height: 100px;
  color: #666;
}
</style>
